export const MY_DESIGN_SERVICES = '/graphic-design/dashboard';
export const MY_ACCOUNT = '/my-account';
export const DESIGN_HUB = '/design';
export const HELP_CENTRE = '/customer-care/help-center/';
